module.exports = __webpack_public_path__ + "img/aplicaciones_escritorio.1adef5a9.jpeg";